export default __webpack_public_path__ + "static/media/clock.cc1952e6.svg";